import { render, staticRenderFns } from "./IdAndPassword.vue?vue&type=template&id=610bcd46&scoped=true"
import script from "./IdAndPassword.vue?vue&type=script&lang=js"
export * from "./IdAndPassword.vue?vue&type=script&lang=js"
import style0 from "./IdAndPassword.vue?vue&type=style&index=0&id=610bcd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bcd46",
  null
  
)

export default component.exports